export interface LocationDto {
  latitude?: number;
  longitude?: number;
}

export interface VehicleLocationDto {
  id: string;
  latitude?: number;
  longitude?: number;
  direction?: number;
  color?: string;
}
